import { useEffect, useState } from 'react';

/**
 * GECİKTİRME (debounce).
 *
 * Arama kutusuna yazan kullanıcı her karakterde bir istek üretmemeli:
 * "Ayşe Demir" on ayrı sorgu demek ve `ILIKE` taraması 3.000 personelde
 * ucuz değil. Değer yazma durduktan `gecikmeMs` sonra yayınlanır.
 */
export function geciktirmeKullan<T>(deger: T, gecikmeMs = 300): T {
  const [gecikmis, gecikmisYaz] = useState(deger);

  useEffect(() => {
    const zamanlayici = setTimeout(() => gecikmisYaz(deger), gecikmeMs);

    // Değer yeniden değişirse önceki zamanlayıcı iptal edilir; aksi halde
    // her karakter kendi zamanlayıcısını kurar ve geciktirme çalışmaz.
    return () => clearTimeout(zamanlayici);
  }, [deger, gecikmeMs]);

  return gecikmis;
}
